<template>
  <div class="mb-2">
    <FieldLabel>{{ label }}</FieldLabel>
    <div
      class="d-flex"
      :style="`width: ${width}`"
    >
      <button
        v-for="item in items"
        :key="item.key"
        class="button w-100 overflow-hidden"
        :class="fieldValue & item.key ? 'selected color-sachlich-white bg-expinet-blue' : 'bg-sachlich-white'"
        :style="`width:${childWidth}`"
        @click="clickHandler(item.key)"
      >
        <span class="w-100 d-inline-block py-1">
          {{ item.label }}
        </span>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { PropType } from 'vue';
import FieldLabel from './FieldLabel.vue';

/* eslint-disable no-bitwise */

export default {
  components: { FieldLabel },

  props: {
    label: { type: String, default: '' },
    fieldName: { type: String, default: '' },
    fieldValue: { type: Number, default: 0 },
    items: { type: Array as PropType<any>, default: () => [] },
    valueChanged: {
      type: Function,
      default: () => console.log('valueChanged not implemented'), // eslint-disable-line no-console
    },
    width: {
      type: String,
      default: '100%',
    },
  },

  computed: {
    childWidth() {
      const index = this.width.match(/[^\d\.]+/)?.index
      const value = parseFloat(this.width.substring(0, index))
      const unit = !!index ? this.width.substring(index) : ''

      return value / this.items.length + unit
    },
  },

  methods: {
    clickHandler(key: any) {
      let newFieldValue = this.fieldValue
      if (newFieldValue & key) {
        newFieldValue = newFieldValue & ~key
      } else {
        newFieldValue = newFieldValue | key
      }
      this.valueChanged(this.fieldName, newFieldValue)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';
@import '@gecko-akh/shared-styles/src/styles/vars.scss';

.button {
  border-top: 2px solid $color-expinet-dark-gray;
  border-bottom: 2px solid $color-expinet-dark-gray;
  border-left: 1px solid $color-expinet-dark-gray;
  border-right: 1px solid $color-expinet-dark-gray;
  cursor: pointer;

  &:first-child {
    border-top-left-radius: $radius-rounded;
    border-bottom-left-radius: $radius-rounded;
    border-left: 2px solid $color-expinet-dark-gray;
  }

  &:last-child {
    border-top-right-radius: $radius-rounded;
    border-bottom-right-radius: $radius-rounded;
    border-right: 2px solid $color-expinet-dark-gray;
  }

  &:hover {
    border-color: $color-expinet-blue-h;
    background-color: $color-expinet-blue-h;
    color: $color-aida-white;
  }
}

.selected {
  border-color: $color-expinet-blue;
}
</style>
